import { login, getUserInfo, getUser } from '@/api/sys'
import { setItem, getItem, removeItem } from '@/utils/storage'
import { TOKEN } from '@/constant'
import router from '@/router'
import { setTimeStamp } from '@/utils/auth'
import store from '../index'

export default {
  namespaced: true,
  state: () => ({
    token: getItem(TOKEN) || '',
    userInfo: {}
  }),
  mutations: {
    setToken(state, token) {
      state.token = token
      setItem(TOKEN, token)
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    /**
     * 初始化路由表
     */
    resetRouter() {
      if (store.getters.userInfo && store.getters.userInfo.permission && store.getters.userInfo.permission.menus) {
        const menus = store.getters.userInfo.permission.menus
        menus.forEach((menu) => {
          router.removeRoute(menu)
        })
      }
    }
  },
  actions: {
    login(context, userInfo) {
      const { username, password } = userInfo
      return new Promise((resolve, reject) => {
        login({
          username,
          password: password
        })
          .then((data) => {
            this.commit('user/setToken', data.access_token)
            // 保存登录时间
            setTimeStamp()
            resolve()
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    async getUserInfo(context) {
      const userInfo = await getUserInfo()
      const user = await getUser()
      this.commit('user/setUserInfo', { ...user, ...userInfo })
      return { ...user, ...userInfo }
    },
    logout() {
      // resetRouter()
      this.commit('user/resetRouter', '')
      this.commit('user/setToken', '')
      this.commit('user/setUserInfo', {})
      this.commit('app/initTagsViewList')
      removeItem(TOKEN)
      removeItem('tagsView')
      removeItem('timeStamp')
      router.push('/login')
    }
  }
}
